import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LogoSemat from "../../../assets/images/semat.png";
import LogoGehl from "../../../assets/images/gehl_footer.webp";
import LogoRoots from "../../../assets/imgs/logo/roots.png";
import LogoBull from "../../../assets/imgs/logo/bull2.png";
import LogoAjax from "../../../assets/imgs/logo/AJAX2.png";

import "./Footer.css";

const Footer = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  const [path, setPath] = React.useState("");

  const location = useLocation();
  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  return (
    <footer className={`wpo-site-footer`}>
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <Link onClick={ClickHandler} className="logo-semat" to="/">
                    <img src={LogoSemat} alt="semat" />
                  </Link>
                </div>
                {!path.includes("others") ? (
                  <div className="logo widget-title">
                    <a
                      rel="noreferrer"
                      href="https://www.gehl.com/fr-FR"
                      target="_blank"
                      className="logo-gehl"
                    >
                      <img src={LogoGehl} alt="semat" />
                    </a>
                  </div>
                ) : (
                  <div>
                    <div className="logo widget-title">
                      <a
                        rel="noreferrer"
                        href="https://www.rootsmulticlean.com/"
                        target="_blank"
                        className="logo-gehl"
                      >
                        <img src={LogoRoots} alt="semat" />
                      </a>
                    </div>
                    <div className="logo widget-title">
                      <a
                        rel="noreferrer"
                        href="https://www.ajax-engg.com/"
                        target="_blank"
                        className="logo-gehl"
                      >
                        <img src={LogoAjax} alt="semat" />
                      </a>
                    </div>
                    <div className="logo widget-title">
                      <a
                        rel="noreferrer"
                        href="https://www.bullindia.com/"
                        target="_blank"
                        className="logo-gehl"
                      >
                        <img src={LogoBull} alt="semat" />
                      </a>
                    </div>
                  </div>
                )}

                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <i className="ti-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <i className="ti-linkedin"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Nos pages</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      Accueil
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/equipement">
                      Equipement
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/accesoires/1">
                      Accesoires
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      A propos de nous
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contactez-Nous
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contactez-Nous </h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    <li>
                      <i className="fi flaticon-location"></i> Route de Sousse
                      km4 2014 <br /> Megrine Riadh, BP 62
                    </li>
                    <li>
                      <i className="fi flaticon-telephone"></i>
                      <a href="tel:25352520">+ (216) 25 352 520</a>
                      <br />
                      <a href="tel:25443300">+ (216) 25 443 300</a>
                      <br />
                      <a href="tel:71392216">+ (216) 71 392 216</a>
                    </li>
                    <li>
                      <i className="fa fa-fax"></i>
                      <a href="tel:71391611">+ (216) 71 391 611</a>
                    </li>
                    <li>
                      <i className="fi flaticon-email"></i>
                      commercial@semat.com.tn
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget instagram">
                <div className="widget-title">
                  <h3>Rendez nous visite </h3>
                </div>

                <div className="gmap_canvas">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.9929960531363!2d10.207848851079682!3d36.77073547985627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd372cf8a6d1d1%3A0x9c245929e7db3a63!2sSte%20%C3%A9quipement%20et%20mat%C3%A9riel!5e0!3m2!1sen!2stn!4v1649976345059!5m2!1sen!2stn"
                    width={320}
                    height="220"
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <ul style={{ display: "unset", color: "#bfb9b5" }}>
                <li>
                  Copyright &copy; {new Date().getFullYear()}, Conçu par :
                  <div>
                    <a
                      onClick={ClickHandler}
                      rel="noreferrer"
                      target="_blank"
                      href="https://www.linkedin.com/in/mahdibouaziz/"
                    >
                      Bouaziz Mahdi
                    </a>
                    &
                    <a
                      onClick={ClickHandler}
                      rel="noreferrer"
                      target="_blank"
                      href="https://www.linkedin.com/in/ramez-ben-aribia/"
                    >
                      Ben Aribia Ramez
                    </a>
                    &
                    <a
                      onClick={ClickHandler}
                      rel="noreferrer"
                      target="_blank"
                      href="https://www.linkedin.com/in/mahdi-hamdi-53b8151a5/"
                    >
                      Hamdi Mahdi
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
